import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: 'terms-conditions',
    loadChildren: () => import('./terms-conditions/terms-conditions.module').then(m => m.TermsConditionsModule)
  },
  {
    path: 'payer-enquiry-result',
    loadChildren: () => import('./payer-enquiry-result/payer-enquiry-result.module').then(m => m.PayerEnquiryResultModule)
  },
  {
    path: 'payer-enquiry',
    loadChildren: () => import('./payer-enquiry/payer-enquiry.module').then(m => m.PayerEnquiryModule)
  },
  {
    path: 'view-integrations',
    loadChildren: () => import('./view-integrations/view-integrations.module').then(m => m.ViewIntegrationsModule)
  },
  {
    path: 'faq',
    loadChildren: () => import('./faq/faq.module').then(m => m.FaqModule)
  },
  {
    path: '',
    loadChildren: () => import('./marketing-home/marketing-home.module').then(m => m.MarketingHomeModule)
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'top'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
